import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function Results() {
  const results = ['Entrás a la primera consulta con más claridad.', 'Formulás el caso integrando envejecimiento, pérdidas, autonomía y red de apoyo.', 'Intervenís en duelo, pérdidas y cambios vitales con más seguridad clínica.', 'Orientás a la familia sin que invada el proceso.', 'Cerrás el proceso terapéutico con criterios claros y continuidad profesional.'];
  return <section className="w-full py-16 md:py-24 bg-white" data-id="element-133">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-134">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-135">
          <h2 className="text-3xl md:text-4xl font-bold text-[#14505c] mb-8 text-center" data-id="element-136">
            EL RESULTADO:
          </h2>
          <div className="bg-gradient-to-br from-[#14505c] to-[#1a3a4a] p-8 md:p-12 rounded-lg shadow-xl" data-id="element-137">
            <ul className="space-y-4" data-id="element-138">
              {results.map((result, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} className="flex items-start gap-3" data-id="element-139">
                  <CheckCircle className="w-6 h-6 text-[#d97706] flex-shrink-0 mt-0.5" data-id="element-140" />
                  <span className="text-white" data-id="element-141">{result}</span>
                </motion.li>)}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>;
}